<template>
  <div v-if="temProximaPagina" class="d-flex justify-content-center my-4">
    <button
      class="btn btn-nd-secondary-outline btn-carregar-mais"
      :disabled="loading"
      data-test="botao-carregar-mais"
      @click="aoClicar"
    >
      <SpinnerLoading v-if="loading" :size="22" data-test="spinner" />
      <template v-else>
        Carregar mais
        <i class="fa fa-chevron-down"></i>
      </template>
    </button>
  </div>
</template>

<script setup>
import { computed, onMounted } from 'vue';
import SpinnerLoading from '../../../../shared/SpinnerLoading.vue';
import { useCarregarMais } from '../composables/useCarregarMais';

const props = defineProps({
  paginaAtual: {
    type: String,
    default: '1'
  },
  proximaPagina: {
    type: String,
    default: ''
  },
  path: {
    type: String,
    required: true
  },
  seletorLinhas: {
    type: String,
    default: '#pedidos-table-body > tr'
  },
  idCarregados: {
    type: String,
    default: 'pedidos-carregados-count'
  },
  idTotal: {
    type: String,
    default: 'pedidos-total-count'
  },
  mensagemErro: {
    type: String,
    default: 'Não foi possível carregar mais pedidos. Tente novamente.'
  }
});

const paginaInicialNumero = Number(props.paginaAtual) || 1;
const proximaPaginaNumero = props.proximaPagina ? Number(props.proximaPagina) : null;

const { loading, carregar, atualizarContagem } = useCarregarMais({
  path: props.path,
  paginaInicial: paginaInicialNumero,
  proximaPaginaInicial: proximaPaginaNumero,
  seletorLinhas: props.seletorLinhas,
  idCarregados: props.idCarregados,
  idTotal: props.idTotal,
  mensagemErro: props.mensagemErro
});

onMounted(() => {
  atualizarContagem();
});

const temProximaPagina = computed(() => Number(props.proximaPagina) > 0);

function aoClicar() {
  carregar();
}
</script>
